import { render, staticRenderFns } from "./PosVendas.vue?vue&type=template&id=999b32ea&scoped=true&"
import script from "./PosVendas.vue?vue&type=script&lang=js&"
export * from "./PosVendas.vue?vue&type=script&lang=js&"
import style0 from "./PosVendas.vue?vue&type=style&index=0&id=999b32ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999b32ea",
  null
  
)

export default component.exports